import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { GdprConfigurationEffects } from './gdpr-configuration.effects';
import { GdprConfigurationNamespace, GdprConfigurationReducer } from './gdpr-configuration.store';

@NgModule({
  imports: [
    StoreModule.forFeature(GdprConfigurationNamespace, GdprConfigurationReducer),
    EffectsModule.forFeature([GdprConfigurationEffects]),
  ],
})
export class GdprConfigurationDataModule {}
